import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleFilled, RedoOutlined, ToolOutlined } from '@ant-design/icons';
import { useNotification } from '../../../../Helper/NotificationProvider';
import '../../Events.scss'
import { fetchLocations, patchLocation } from '../../../../slices/locationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { addMatching } from '../../../../slices/matchingSlice';
import { patchEvent } from '../../../../slices/eventSlice';

const MultipleResetButton = ({ editorRef, location, guestList, event, fetchEvent, patcheData, setPatchedData, template, marginLeft }) => {
  const { openNotification } = useNotification();
  const { confirm } = Modal;
  const dispatch = useDispatch();

  const showResetConfirm = () => {
    if(editorRef.current.getSelectedIds()?.length === 0){
      openNotification(
        "bottomRight",
        "Keine Stühle markiert",
        "Bitte markieren Sie mindestens 2 oder mehr Stühle um diese zurückzusetzen.",
        false
      )
      return
    }
    confirm({
      title: template === "Default" ? 'Markierte Stühle zurücksetzen' : "Wartungsdisplay anzeigen",
      icon: <ExclamationCircleFilled />,
      content: template === "Default" ? 'Sind Sie sicher, dass Sie alle markierten Stühle zurücksetzen wollen?' :
        'Sind Sie sicher, dass Sie alle markierteb Stühle auf das Wartungsdisplay umschalten wollen?',
      okText: 'Ja',
      okType: 'danger',
      cancelText: 'Nein',
      onOk() {
        handleReset(location, guestList)
      },
      onCancel() {
      },
    });
  };

  const handleReset = async (location, guestList) => {
    try {
      const selectedIds = editorRef.current.getSelectedIds();
      const updatedGuestList = guestList.map(guest => {
        if (!selectedIds.includes(guest.chair)) {
          return guest; // leave untouched
        }
        // reset fields for selected chairs
        return {
          ...guest,
          name: "",
          surname: "",
          title: "",
          companyInfo: "",
          message: "",
          matching: {
            customFields: {},
            matched: false,
            label: "",
            template: ""
          }
        };
      });

      const updatedScanPaths = location?.scanPaths.map((scanPath) => {
        if (!scanPath.path || scanPath.path.length === 0) {
          return scanPath;
        }

        return {
          ...scanPath,
          currentMatchingMarker: scanPath.path[0],
        };
      });

      await dispatch(
        patchLocation({
          locationId: location._id,
          updateData: {
            scanPaths: updatedScanPaths,
          },
        })
      );

      await dispatch(patchEvent({
        eventId: event.key,
        changes: {
          guestList: updatedGuestList
        }
      }))


      const labels = guestList
        .filter((guest) => selectedIds.includes(guest.chair) && !!guest.matching?.label)
        .map((guest) => {
          return {
            objectId: guest.matching.label,
            data: [
              {
                zoneId: 'template',
                value: template,
              },
              {
                zoneId: 'chair',
                value: '',
              },
              {
                zoneId: 'number',
                value: '',
              },
              {
                zoneId: 'row',
                value: ''
              },
              {
                zoneId: 'block',
                value: ''
              },
              {
                zoneId: 'name',
                value: '',
              },
              {
                zoneId: 'surname',
                value: ''
              },
              {
                zoneId: 'company',
                value: '',
              },
              {
                zoneId: 'message',
                value: '',
              },
              {
                zoneId: 'title',
                value: ''
              }
            ]
          };
        });

      if (labels.length > 0) {
        await dispatch(addMatching({
          labels: labels,
          config: {
            params: {
              resetFields: true
            }
          }
        }));
      }
      template === "Default" ?
        openNotification(
          "bottomRight",
          "Markierten Stühle zurückgesetzt",
          "Alle markierten Stühle des Events wurden zurückgesetzt.",
          true
        ) :
        openNotification(
          'bottomRight',
          'Wartungsdisplay angezeigt',
          "Alle markierten Stühle des Events wurden auf das Wartungsdisplay gewechselt.",
          true
        )

      await dispatch(fetchLocations());
      await fetchEvent()
      setPatchedData(!patcheData);
    } catch (error) {
      console.error("Error resetting location:", error);
      openNotification(
        "bottomRight",
        "Fehler",
        "Stühle konnten nicht umgeschalten werden. Bitte später erneut versuchen.",
        false
      );
    }
  };


  return (
    <Button
      type="primary"
      className="reset-mult-btn"
      icon={template === "Default" ? <RedoOutlined /> : <ToolOutlined/>}
      onClick={() => showResetConfirm()}
      style={{ marginLeft: marginLeft, marginBottom: 0 }}
    >
      {template === "Default" ? "Markierte Stühle zurücksetzen" : "Wartungsdisplay anzeigen"}
    </Button>
  );
};

export default MultipleResetButton;
